export const vehicleModelsResource = {
  name: '車輛型號',
  fields: {
    id: 'ID',
    name: '型號',
    normalizedName: '標準化名稱',
    brand: '品牌',
    brandName: '品牌',
    translationEn: '名稱（English）',
    translationZhTw: '名稱（繁體中文）',
    translationZhCn: '名稱（简体中文）',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
  sections: {
    details: '型號詳細資料',
  },
  help: {
    brandImmutable: '建立後無法變更品牌。',
  },
  actions: {
    importPdf: '從 PDF 匯入',
    importCsv: '從 CSV 匯入',
  },
  create: {
    title: '新增車輛型號',
  },
  edit: {
    title: '編輯車輛型號',
  },
  notifications: {
    created: '已建立車輛型號',
    updated: '已更新車輛型號',
  },
  errors: {
    duplicate: '此品牌下已有相同名稱的型號',
    brandNotFound: '找不到品牌',
  },
  import: {
    title: '從 CSV 匯入型號',
    uploadHint: '選擇 CSV 檔案（上限 10MB），須包含「brand_name」和「model_name」欄位。',
    uploadHintLine2: '提示：可使用 parse-epd-ev-pdf 技能將環保署 PDF 轉換為此格式。',
    selectFile: '選擇檔案',
    parsing: '正在解析檔案並比對現有型錄...',
    summary: '共 %{total} 筆：%{fresh} 筆新增，%{existing} 筆已存在（將略過）。',
    willInsert: '將新增（%{count}）',
    willSkip: '已存在於型錄 — 將略過（%{count}）',
    addOnlyNote: '系統不會刪除現有的品牌或型號，僅新增不存在的項目。',
    submit: '匯入 %{count} 筆新資料',
    submitting: '匯入中...',
    completeMsg: '匯入完成。',
    rowsReceived: '收到的資料筆數',
    brandsCreated: '新增的品牌數',
    modelsInserted: '新增的型號數',
    modelsSkipped: '略過的型號數（已存在）',
    success: '型號已匯入',
    errors: {
      notSupported: '請選擇 CSV 檔案',
      tooLarge: '檔案過大（上限 10MB）',
      parseFailed: '檔案解析失敗',
    },
  },
};

export const vehicleModels = {
  'vehicle-models': vehicleModelsResource,
};
